import { CommonModule } from "@angular/common";
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";
import { IonicModule } from "@ionic/angular";

import { SliderComponent } from "./slider.component";

@NgModule({
  declarations: [SliderComponent],
  imports: [CommonModule, IonicModule, RouterModule],
  exports: [SliderComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],  // using swiper as "global" Webcomponent, not Angular-component. Need CUSTOM_ELEMENTS_SCHEMA to work
})
export class SliderComponentModule {}
